<template>
  <div>
    <section class="main-content">

        <div class="main-block main-block-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-articles bck-views">
                            <h2 class="title">
                                <span>{{this.songView.title}}</span>
                                <span v-if="!this.authorized" class="addtofav" href="#" data-toggle="modal" data-target="#loginpanel" title="會員登入">
                                  <i class="fa fa-heart-o" aria-hidden="true"></i>
                                  <span>收藏</span>
                                </span>
                                <span v-if="this.authorized" class="addtofav" @click="addToFavorite" v-bind:class="favoriteData">
                                  <i class="fa fa-heart-o" aria-hidden="true"></i>
                                  <span>收藏</span>
                                </span>
                                <span class="sub-title">by {{this.songView.author}}</span>
                            </h2>
                            <article class="article-editor" v-html="this.songView.context"></article>
                            <a :href="'/songCategory/'+songView.category_id">
                              <span class="badge badge-primary">{{songView.category_name}}</span>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title title-bg-music"><span>推薦歌曲 - 歌詞與video</span></h3>
                            <div class="articles-items articles-songview">
                                <div class="row">
                                    <div class="col-lg col-sm-6 push-sm-6">
                                        <div class="embed-responsive embed-responsive-16by9">
                                            <iframe class="embed-responsive-item" :src="songView.link"></iframe>
                                        </div>
                                    </div>
                                    <div class="col-lg col-sm-6 pull-sm-6">
                                        <article class="article-editor article-lyrics" v-html="songView.lyric"></article>
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <div class="fb-like" :data-href="'https://www.weddingsung.com/songs/'+this.$route.params.id" data-layout="standard" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
                            <Fbcomment :videoId="this.$route.params.id"></Fbcomment>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="bck-index bck-articles">
                            <h3 class="title"><span>歌曲使用分享</span></h3>
                            <div class="articles-items">

                                <div class="row">
                                    <div class="col-sm-6"  v-for="(row, index) in share">
                                        <div class="articles-box videoshare-box">
                                            <div class="embed-responsive embed-responsive-16by9">
                                                <iframe class="embed-responsive-item" :src="row.link"></iframe>
                                            </div>
                                            <blockquote class="blockquote article-blockquote">
                                              <h6 class="title mb-0 text-primary">{{row.title}}</h6>
                                              <footer class="blockquote-footer">{{row.name}}</footer>
                                              <article class="article-editor">
                                                <p class="txt">
                                                  {{row.context | truncate(250) | doubledot}}
                                                </p>
                                              </article>
                                            </blockquote>
                                        </div>
                                    </div>
                                </div>
                                <div class="articles-box contact-box songshare-box">
                                    <div class="text text-bg">
                                        <h5 class="title text-primary text-center">
                                          如果你在婚禮上也使用過這首歌，<br />歡迎上傳這首歌的婚禮 video
                                        </h5>
                                        <div class="row">
                                            <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
                                              <form class="contact-form songshare-form" action="" method="post">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class=" col-form-label-sm" for="name">姓名</label>
                                                            <input type="text" class="form-control form-control-sm" v-model="name"/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label class=" col-form-label-sm" for="videolink">影片連結</label>
                                                            <input type="text" class="form-control form-control-sm" v-model="link"/>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label class=" col-form-label-sm" for="message">分享內容</label>
                                                            <textarea class="form-control form-control-sm" id="message" rows="4" v-model="context"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" @click="shareSong" class="btn btn-primary btn-block">送出</button>
                                              </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Fbcomment from '../components/Fbcomment.vue'
import Qs from 'qs'
export default {
  name: 'songsview',
  data () {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      songId: this.$route.params.id,
      songView: Object,
      share: [],
      name: '',
      link: '',
      context: '',
      favoriteData: {
        active: false
      },
      favorite: 0
    }
  },
  components: {
    Fbcomment
  },
  computed: {
    ...mapGetters([
      'getUri'
    ])
  },
  created: function () {
    let token = window.localStorage.getItem('token')
    if (token === '' || token === 'null') {
      this.authorized = false
      console.log(this.authorized)
    } else {
      this.authorized = this.$store.getters.getAuth
      console.log(this.authorized)
    }
    let self = this
    let dataPost = Qs.stringify({
      token: this.token,
      song_id: this.songId,
      user_id: this.user_id
    })
    self.$http.post(this.uri + 'Song/get_song/', dataPost).then(function (res) {
      let data = res.data
      if (data.status === 200) {
        self.songView = data.song
        self.share = data.share
        if (data.song.favoriteID > 0) {
          self.favoriteData.active = true
        }
      } else {
        console.log('fail')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  methods: {
    ...mapActions([
      'UPDATEUSER'
    ]),
    addToFavorite () {
      let str = ''
      let self = this
      if (this.favoriteData.active === true) {
        str += '您已經收藏過此首歌曲\n'
      } else if (this.token === '' || typeof this.token === 'undefined') {
        str += '請您先登入，再進行收藏\n'
      }
      if (str === '') {
        let data = Qs.stringify({
          token: this.token,
          song_id: this.songId
        })
        this.$http.post(this.uri + 'User/add_song_favorite', data).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            self.favoriteData.active = true
            window.alert('收藏成功')
          } else {
            window.alert('收藏失敗')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert(str)
        return false
      }
    },
    shareSong () {
      let str = ''
      if (this.name === '' || typeof this.name === 'undefined') {
        str += '請輸入您的信箱\n'
      } else if (this.link === '' || typeof this.link === 'undefined') {
        str += '輸入影片連結\n'
      }
      if (str === '') {
        let data = Qs.stringify({
          name: this.name,
          link: this.link,
          context: this.context,
          user_id: this.userId,
          song_id: this.songId,
          title: this.songView.title
        })
        this.$http.post(this.uri + 'Share/add_share_song/', data).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            window.alert('上傳成功，謝謝您的分享')
            this.name = ''
            this.context = ''
            this.link = ''
          } else {
            console.log('fail')
          }
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert(str)
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SongsView.vue?0b710b18